import { render, staticRenderFns } from "./PesquisaWhatsappRedesSociais.vue?vue&type=template&id=492a337c&scoped=true"
import script from "./PesquisaWhatsappRedesSociais.vue?vue&type=script&lang=js"
export * from "./PesquisaWhatsappRedesSociais.vue?vue&type=script&lang=js"
import style0 from "./PesquisaWhatsappRedesSociais.vue?vue&type=style&index=0&id=492a337c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a337c",
  null
  
)

export default component.exports